import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { isAuthTokenValid } from "../commons/AuthTokenUtils";

export const AuthorProtectedRoute = (props: {
  children: ReactElement;
}): ReactElement => {
  if (!isAuthTokenValid()) {
    return <Navigate to="/user/login" />;
  }
  return props.children;
};
